import { createApp } from "vue"
import ContactStepCategoryContent from "./ContactStepCategoryContent.options"

const el = ".nyk-component--contact-step-category-content"

export default function (Store) {
  const DOM = document.querySelectorAll(el)
  if (DOM.length) {
    DOM.forEach((ContactStepInfoDOM) => {
      const component = createApp(ContactStepCategoryContent).use(Store)
      component.mount(ContactStepInfoDOM)
    })
  }
}
